import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Cross, Flame, Star, Sun, Leaf } from "lucide-react";
import { api } from "@/lib/api";

const ICONS: Record<string, any> = { advent: Star, christmas: Star, lent: Cross, holyweek: Leaf, easter: Sun, pentecost: Flame };

export function ChurchSeason({ kids }: { kids?: boolean }) {
  const [s, setS] = useState<any>(null);
  useEffect(() => {
    const on = new URLSearchParams(window.location.search).get("church");
    api.get(`/church-season${on ? `?on=${on}` : ""}`).then((r) => setS(r.data)).catch(() => {});
  }, []);
  if (!s) return null;
  const Icon = ICONS[s.id] || Star;
  return (
    <motion.section initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} data-testid="church-season" data-season={s.id} data-active={s.active ? "yes" : "no"}
      className={`relative overflow-hidden rounded-[2rem] p-6 text-white shadow-xl sm:p-8 ${kids ? "" : "mb-8"}`}
      style={{ background: `radial-gradient(circle at 85% 20%, rgba(255,255,255,.25), transparent 45%), linear-gradient(135deg, ${s.color}, #1E293B)` }}>
      {Array.from({ length: 14 }, (_, i) => (
        <span key={i} className="church-twinkle absolute rounded-full bg-white" style={{ left: `${(i * 37) % 100}%`, top: `${(i * 53) % 100}%`, width: 2 + (i % 3), height: 2 + (i % 3), animationDelay: `${i * 0.4}s` }} />
      ))}
      <div className="relative flex flex-wrap items-start gap-4">
        <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-white/15 ring-1 ring-white/30"><Icon className="h-7 w-7" /></span>
        <div className="min-w-0 flex-1">
          <p className="text-[11px] font-semibold uppercase tracking-[0.24em] text-white/80" data-testid="church-season-label">
            {s.active ? `The church year · ${s.label}` : `${s.label} begins in ${s.days_until} day${s.days_until === 1 ? "" : "s"}`}
          </p>
          <h2 className={`mt-1 font-semibold ${kids ? "text-3xl" : "font-display text-3xl"}`} data-testid="church-season-message">{s.message}</h2>
          {s.text && <p className="mt-3 max-w-2xl font-scripture text-lg italic text-white/90">“{s.text}”</p>}
          <p className="mt-1 text-sm font-semibold text-white/80">{s.ref}{s.abbr ? ` · ${s.abbr}` : ""}</p>
        </div>
      </div>
    </motion.section>
  );
}
